import { PlaylistAddOutlined } from "@mui/icons-material";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { stat } from "fs";
import { PageStore } from "../PageStore";
import { ImagePopProps } from "../../layoutPages/containers/ImagePop";
import { VideoLinkItem } from "../Classes/VideoLinkItem";

//Step 1.
export interface CommonComponentStatus {
    popUpImageProps?: ImagePopProps;
    popUpZoomIn: boolean;
    subjectMenuTabIndex: number;
    ReportMenuTabIndex: number;
    scrollTop: number;
    videoListOpen: boolean;
    videoListTitle?: string;
    videoListData?: VideoLinkItem[];
}
//Step 2.
const initialState: CommonComponentStatus = {
    popUpImageProps: undefined,
    popUpZoomIn: false,
    subjectMenuTabIndex: 0,
    ReportMenuTabIndex: 0,
    scrollTop: 0,
    videoListOpen: false,
    videoListTitle: undefined,
    videoListData: undefined,
};

const CommonComponentSlicer = createSlice({
    name: 'ComponentSlicer',
    initialState,
    reducers: {
        //Step 3.
        changePopUpStates: (state, action: PayloadAction<ImagePopProps>) => {
            state.popUpZoomIn = true; 
            state.popUpImageProps = action.payload 
        },
        closePopUp: (state) => { 
            state.popUpZoomIn = false 
        },
        setSubjectMenuTabIdx: (state, action) => {
            state.subjectMenuTabIndex = action.payload;
        },
        setReportMenuTabIdx: (state, action) => {
            state.ReportMenuTabIndex = action.payload;
        },
        setScrollTop: (state, action) => {
            state.scrollTop = action.payload
        },
        openVideoList: (state, action: PayloadAction<{ title?: string; data: VideoLinkItem[] }>) => {
            state.videoListOpen = true;
            state.videoListTitle = action.payload.title;
            state.videoListData = action.payload.data;
        },
        closeVideoList: (state) => {
            state.videoListOpen = false;
        },
    }
});
//Step 4.
export const {
    changePopUpStates,
    closePopUp,
    setSubjectMenuTabIdx,
    setReportMenuTabIdx,
    setScrollTop,
    openVideoList,
    closeVideoList,
} = CommonComponentSlicer.actions;
//----------------------
export const CommonComponentReducer = CommonComponentSlicer.reducer; //No need to change